import { AvTimer, RadioButtonUnchecked, TaskAlt } from '@mui/icons-material';
import { Box, ButtonBase, Card, Typography } from '@mui/material';
import _ from 'lodash';
import moment from 'moment';
import i18n from '../../../i18n';
import { Warrant } from '../../../models';
import './scss/auth-card.style.scss';
import { AuthDeleteList } from './authorization-data';
import { auth_default_png } from '../../../static/images';
import AuthCardSkeleton from './auth-card-skeleton';
import { accountState } from '../../my-account/account-state';
import { getAuthPointI18n } from '../../../constants/tool-auth-point';


/**
 * 授权卡片组
 */
export function AuthCardGroup(props: {
    dataList: Warrant[];
    viewMode: 'DETAIL' | 'SUMMARY';
    showSelectBox: boolean;
    selectedList: AuthDeleteList[];
    onClick: (wararntItem: Warrant) => void;
    showSkeleton: boolean;
}) {
    const { dataList, viewMode, showSelectBox, selectedList, onClick, showSkeleton } = props;
    // 是否被选中 - 汇总模式
    const checkSelectStatus = (warrants: Warrant[]) => {
        const deleteList = _.cloneDeep(selectedList);
        const ids = warrants.map(item => item._id);
        const copyIds = new Set(ids);
        const result = deleteList.filter(i => {
            return i.warrant_id.every(j => copyIds.has(j))
        });
        return result.length > 0
    }


    return (
        showSkeleton
            ? <AuthCardSkeleton />
            : dataList.length ? (
                <Box className='auth-card-list'>
                    {/* 详细模式 */}
                    {viewMode === 'DETAIL' && dataList.map((item, index) => {
                        return <Box key={index}>
                            <Typography>{item.code}</Typography>
                            <Box display={'flex'} flexWrap='wrap'>
                                {item?.warrants?.map((wararntItem, wararntItemIndex) => {
                                    const selected = selectedList.map(ele => ele.warrant_id.find(n => n === wararntItem._id)).includes(wararntItem._id!);
                                    // 筛选出对应国际化授权名字
                                    const filterI18nName = getAuthPointI18n(wararntItem?.warranti18N?.name || []);
                                    return <AuthCard
                                        key={wararntItemIndex}
                                        name={filterI18nName}
                                        startDate={wararntItem?.limit_point?.start_date}
                                        endDate={wararntItem?.limit_point?.end_date}
                                        type={'single'}
                                        showSelectBox={showSelectBox}
                                        selected={selected}
                                        onClick={() => { onClick(wararntItem) }}
                                    />
                                })}
                            </Box>
                        </Box>
                    })}
                    {/* 汇总模式 */}
                    {viewMode === 'SUMMARY' &&
                        <Box display={'flex'} flexWrap='wrap'>
                            {dataList.map((wararntItem, index) => {
                                const selected = checkSelectStatus(wararntItem?.warrants || []);
                                let newType: 'mltiple' | 'single' = 'single';
                                const startDate = wararntItem?.start_date;
                                let endDate = wararntItem?.end_date;
                                // 汇总模式 && 包含多个相同权限点，显示重叠样式
                                if ((wararntItem?.warrants?.length || 0) > 1) {
                                    newType = 'mltiple';
                                    // 找出最晚的时间端 - 结束时间
                                    endDate = wararntItem?.warrants?.reduce((pre, cur) => {
                                        if (moment(endDate, moment.HTML5_FMT.DATETIME_LOCAL_MS).isAfter(cur?.limit_point?.end_date)) {
                                            return pre
                                        }
                                        return cur?.limit_point?.end_date
                                    }, endDate)
                                }
                                // 筛选出对应国际化授权名字
                                const filterI18nName = getAuthPointI18n(wararntItem?.warranti18N?.name || []);
                                return <AuthCard
                                    key={index}
                                    name={filterI18nName}
                                    startDate={startDate}
                                    endDate={endDate}
                                    type={newType}
                                    showSelectBox={showSelectBox}
                                    selected={selected}
                                    onClick={() => { onClick(wararntItem || []) }}
                                />
                            })}
                        </Box>
                    }

                </Box >
            ) : (<Box>{i18n.t('general_text_no_or_more_data')}</Box>))
}

/**
 * 授权点卡片
 */
export function AuthCard(props: {
    name: string;
    startDate?: Date;
    endDate?: Date;
    // 选择器 | 单个显示  | 多个显示重叠
    type: 'chooser-single' | 'chooser-mltiple' | 'single' | 'mltiple';
    showSelectBox: boolean;
    selected: boolean;
    onClick: () => void;
    authPng?: string;
    disabled?: boolean,
    price?: number
}) {
    const formatDate = (date?: Date) => { return date ? moment(date, moment.HTML5_FMT.DATETIME_LOCAL_MS).format('DD/MM/YYYY') : '' };
    return (
        <ButtonBase
            className={`auth-card-button ${props.type.includes('mltiple') ? 'auth-card-button-mltiple' : null}`}
            onClick={props.onClick}
            disabled={props.disabled}
        >
            <Card
                className={`auth-card-item `}
            >
                {
                    props.showSelectBox && (
                        <Box className='auth-card-item-select-box'  >
                            {
                                props.selected ? <TaskAlt /> : <RadioButtonUnchecked />
                            }
                        </Box>
                    )
                }
                <Box className='auth-card-top'>
                    <img className='auth-card-img' src={props.authPng ?? auth_default_png} alt='' />
                    <Box className='auth-card-title'>
                        {props.name}
                    </Box>
                    {
                        (accountState.accountType === 'RESELLER' && props.price) ?
                            <Box className='auth-card-title'>
                                {`${props.price?.toFixed(2)} €`}
                            </Box> : <></>
                    }

                </Box>
                {!props.type.includes('chooser') && <Box className='card-item-footer-bar'>
                    <Box className='card-item-footer-bar-box'>
                        <AvTimer />
                        <Typography className='card-item-footer-bar-box-text'>
                            {`${formatDate(props.startDate)} - ${formatDate(props.endDate)}`}
                        </Typography>
                    </Box>
                </Box>}
            </Card>
        </ButtonBase >
    )
}